import { keyBy } from 'lodash';
import { Chip, Stack, Typography } from '@common-components';
import { PlacementTaskStatus } from 'enums';
import { useSearchInsuranceProduct } from 'hooks/api/insuranceProduct';
import { messages } from 'i18n';
import { ArrowForward } from 'components/icons';
import { BasePlacementTaskItem } from './BasePlacementTaskItem';
import { PlacementTaskItemProps } from './types';

export function RemarketingPlacementTaskItem(props: PlacementTaskItemProps) {
  const { task } = props;
  const isSkipped = task.status === PlacementTaskStatus.Skipped;
  const productIds = task.stepConfig.productIds ? task.stepConfig.productIds : [];

  const { items: allProducts, isLoading: isLoadingProducts } = useSearchInsuranceProduct();

  // Map over productIds to preserve their order (important for display sequence)
  const productMap = keyBy(allProducts, 'id');
  const products = productIds.map((id) => productMap[id]).filter(Boolean);

  return (
    <BasePlacementTaskItem {...props}>
      {productIds.length > 0 && (
        <Stack
          direction="row"
          flexWrap="wrap"
          gap={0.5}
          sx={{
            opacity: isSkipped ? 0.6 : 1,
          }}
        >
          {isLoadingProducts ? (
            <Typography variant="caption" color="textSecondary">
              {messages.placementProcess.dialog.loadingMarkets}
            </Typography>
          ) : (
            products.map((product, index) => (
              <>
                <Chip key={product.id} label={product.marketName} size="small" variant="contained" color="secondary" />
                {index < products.length - 1 && <ArrowForward fontSize="small" color="action" />}
              </>
            ))
          )}
        </Stack>
      )}
    </BasePlacementTaskItem>
  );
}
